import React from 'react';
import { CTAButton } from '../CTAButton';
import { DOCTOR_IMAGE } from '../../data/content';
const patientFindings = ['An elevated creatinine', 'A declining eGFR', 'Albuminuria', 'Hyperkalemia', 'Diabetes', 'Hypertension', 'Multiple medications'];
export function AboutDoctor() {
  return <section className="w-full bg-white px-4 py-14 sm:px-6 sm:py-20" data-id="element-63" data-mp="2yg789fvkdf7r">
      <div className="mx-auto max-w-5xl" data-id="element-64" data-mp="20s6ryc9sicgj">
        <div className="grid grid-cols-1 items-start gap-8 lg:grid-cols-[minmax(0,340px)_minmax(0,1fr)] lg:gap-12" data-id="element-65" data-mp="20thwwfez1q98">
          <div className="mx-auto w-full max-w-[300px] lg:max-w-none lg:sticky lg:top-8" data-id="element-66" data-mp="25rjgr2k81tlr">
            <img src={DOCTOR_IMAGE} alt="Dr. Karito, physician and creator of Kidney Disease Route™" className="w-full rounded-3xl object-cover" loading="lazy" data-id="element-67" data-mp="2aos1nawr8bqp" />
            <p className="mt-3 text-center font-display text-lg font-bold text-navy-900 lg:text-left" data-id="element-68" data-mp="1hzut3zichtb5">
              Dr. Karito
            </p>
            <p className="text-center text-[13px] font-medium text-navy-500 lg:text-left" data-id="element-69" data-mp="xzxn32pftzvl">
              Creator of Kidney Disease Route™
            </p>
          </div>

          <div data-id="element-70" data-mp="o9mfn66jp8jy">
            <p className="text-[11px] font-extrabold uppercase tracking-[0.16em] text-brick-600 sm:text-xs" data-id="element-71" data-mp="o9cr7n15f9gd">
              About Dr. Karito
            </p>
            <h2 className="mt-2.5 text-balance font-display text-[26px] font-bold leading-tight text-navy-900 sm:text-4xl" data-id="element-72" data-mp="k66jsc2avc8b">
              Why I created Kidney Disease Route™
            </h2>

            <div className="mt-5 space-y-3.5 text-[14.5px] font-medium leading-relaxed text-navy-600 sm:text-base" data-id="element-73" data-mp="a8s7monet9lt">
              <p data-id="element-74" data-mp="5ctk139wnvmg">For years, I saw the same problem repeatedly.</p>
              <p data-id="element-75" data-mp="1aznn76qtds3">
                Physicians weren’t necessarily lacking knowledge. They were lacking a clear way to
                turn that knowledge into a decision. The guidelines contain the information.
              </p>
              <p data-id="element-76" data-mp="1vllhji2c284h">But when you’re sitting across from a patient with:</p>
            </div>

            <ul className="mt-4 flex flex-wrap gap-2" data-id="element-77" data-mp="3p428cfwui3xf">
              {patientFindings.map(finding => <li key={finding} className="rounded-full border border-navy-100 bg-cream px-3 py-1.5 text-[12.5px] font-semibold text-navy-700 sm:text-[13.5px]" data-id="element-78" data-mp="3tyq0qpuyziha">
                  {finding}
                </li>)}
            </ul>

            <div className="mt-5 space-y-3.5 text-[14.5px] font-medium leading-relaxed text-navy-600 sm:text-base" data-id="element-79" data-mp="bpfov2kusjug">
              <p data-id="element-80" data-mp="2qkgbjuc6xnz">
                …the question isn’t “Where is the information?” The real question is:{' '}
                <strong className="font-bold text-navy-900" data-id="element-81" data-mp="7p5kfucpm1hp">
                  “What should I do with THIS patient right now?”
                </strong>
              </p>
              <p data-id="element-82" data-mp="2nj5v1qqg7i7r">
                That’s why I created Kidney Disease Route™. Not as another textbook. Not as another
                collection of guidelines. And not as something you’re expected to read from beginning
                to end.
              </p>
              <p data-id="element-83" data-mp="2fwigkhhw8w7k">
                I designed it as a practical clinical decision system that organizes complex renal
                recommendations into clear, visual pathways.
              </p>
            </div>

            <p className="mt-5 rounded-2xl bg-navy-900 px-5 py-4 font-display text-[19px] font-bold leading-snug text-white sm:text-[22px]" data-id="element-84" data-mp="2oyi31pbogshw">
              Walk into your next renal consultation with a map instead of uncertainty.
            </p>
          </div>
        </div>

        <div className="mt-10 sm:mt-12" data-id="element-85" data-mp="2az8v1cxml4p0">
          <CTAButton label="I want the clinical route" subline="6 clinical volumes • 5 premium bonuses • Lifetime access" data-id="element-86" data-mp="2b0a8tp6105af" />
        </div>
      </div>
    </section>;
}